import React from "react";
import { cn } from "../ui";

const STEPS = [
  { key: "form", label: "Describe" },
  { key: "review", label: "Review" },
];

/** "1 Describe · 2 Review" — where an AI drafting dialog is in its two steps.
 *  Both quiz-bank AI dialogs (questions, subtopics) show it. */
export default function AiDialogSteps({ step }) {
  return (
    <ol className="tw-m-0 tw-mb-4 tw-flex tw-list-none tw-items-center tw-gap-2 tw-p-0 tw-text-[0.8125rem]" aria-label="Steps">
      {STEPS.map((s, i) => {
        const current = s.key === step;
        return (
          <li key={s.key} className="tw-flex tw-items-center tw-gap-2" aria-current={current ? "step" : undefined}>
            {i > 0 && <span aria-hidden="true" className="tw-text-content-subtle">·</span>}
            <span className={cn(current ? "tw-font-semibold tw-text-primary" : "tw-text-content-muted")}>
              {i + 1} {s.label}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
